export const FeatureFlags = {
  CROSS_SELL_FEATURE_ENABLED: true
};
